import {paths} from '@src/consts';
import localStore from '@src/utils/storage';
import axios from 'axios';
import apiStore from './index';

const GetConfig= () => {
    const urlList=paths.configuration;
    return ( async () => {
            let configData = null;
        
            for( let url of urlList ){
                try{
                    const { data } = await axios.get( url );
                    localStore.set( 'configuration', data );
                    configData = data;
                    break;
                }
                catch( error ){
                    Logger.log( error );
                    continue;
                }
            }
            return configData;
    } )();
}

const FetchLocate = async () => {
     try{
        const { data:body } = await apiStore.axios.get( paths.locate );
        const country = body?.success ?? null ;
        return country;
     }
     catch( error ){
         Logger.log( error );
     }
}

export { GetConfig, FetchLocate };